import React from 'react';

const IndustriesSection = () => {
  const industries = [
    'Energy',
    'Oil & Gas',
    'Mining',
    'Government & Public Sector',
    'Hospitality',
    'Engineering',
    'Software as a Service (SaaS)',
    'Environmental Services',
    'Infrastructure',
    'IT Managed Security Service Providers (MSSP)',
    'Healthcare'
  ];

  return (
    <section id="industries" className="industries-section">
      <div className="industries-container">
        <div className="section-header">
          <h2 className="section-title">Industries Served</h2>
        </div>

        <div className="industries-grid">
          {industries.map((industry, index) => (
            <div key={index} className="industry-item">
              <span className="industry-name">{industry}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;
